:host {
  display: none;
}

:host([active]) {
  display: block;
}

.tooltip__arrow {
  position: absolute;
  width: 28px;
  height: 12px;
  overflow: hidden;
}

.tooltip__arrow::before {
  content: "";
  position: absolute;
  display: block;
  background-color: #ffffff;
  visibility: visible;
  width: 12px;
  height: 12px;
  top: 0;
}

:host(:not([dir="rtl"])) .tooltip__arrow::before {
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  left: 50%;
  box-shadow: 2px 2px 4px 0 rgba(51, 51, 51, 0.15);
}

:host([dir="rtl"]) .tooltip__arrow::before {
  transform: translateX(50%) translateY(-50%) rotate(-45deg);
  right: 50%;
  box-shadow: -2px 2px 4px 0 rgba(51, 51, 51, 0.15);
}

:host([data-popper-placement^=top]) .tooltip__arrow {
  bottom: -12px;
}

:host([data-popper-placement^=bottom]) .tooltip__arrow {
  top: -12px;
}

:host([data-popper-placement^=bottom]) .tooltip__arrow::before {
  top: auto;
  bottom: -12px;
}

:host(:not([dir="rtl"])[data-popper-placement^=bottom]) .tooltip__arrow::before {
  transform: translateX(-50%) translateY(-50%) rotate(315deg);
}

:host([dir="rtl"][data-popper-placement^=bottom]) .tooltip__arrow::before {
  transform: translateX(50%) translateY(-50%) rotate(-315deg);
}

.tooltip__content {
  display: block;
  margin: 0;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(51, 51, 51, 0.05), 0 5px 5px 0 rgba(51, 51, 51, 0.15);
}

.tooltip__content--option-fill {
  padding-top: 16px;
  padding-bottom: 16px;
}

.tooltip__content--option-indent {
  padding: 16px;
}